import React from 'react'
import _ from 'lodash'

import {
  Dimensions,
  StyleSheet,
  Platform,
  LayoutChangeEvent,
  View,
  TouchableWithoutFeedback,
  Keyboard,
  EmitterSubscription,
} from 'react-native'
import Modal from 'react-native-modal'

import { IXOverlayProps } from 'x/index'

import CONS from 'x/config/constants'
import VStack from './VStack'
import XIconButton from './XIconButton'
import { withWebBackHandler, WithWebBackHandlerProps } from './withWebBackHandler'
// import XKeyboardAvoidingView from './XKeyboardAvoidingView'
// import { log, setStatePromise } from 'x/utils/util'
// import NativeBaseProvider from 'xui/components/NativeBaseProvider'

// import VStack from 'xui/components/VStack'

const DEVICE_WIDTH = Dimensions.get('window').width
const DEVICE_HEIGHT = Dimensions.get('window').height

// const MIN_CONTENT_WIDTH = Math.floor(DEVICE_WIDTH / 2)
// const MAX_CONTENT_WIDTH = DEVICE_WIDTH - 32
// const INITIAL_CONTENT_WIDTH = Math.floor(MAX_CONTENT_WIDTH * 0.75)

// // const MIN_CONTENT_HEIGHT = Math.floor(DEVICE_HEIGHT / 4)
// const MIN_CONTENT_HEIGHT = 50
// const MAX_CONTENT_HEIGHT = DEVICE_HEIGHT - 64
// const INITIAL_CONTENT_HEIGHT = Math.floor(MAX_CONTENT_HEIGHT * 0.75)

interface IXOverlayState {
  containerWidth: number
  containerHeight: number
  keyboardVisible: boolean
}

class XOverlay extends React.Component<IXOverlayProps & WithWebBackHandlerProps, IXOverlayState> {
  static displayName = 'XOverlay'

  static defaultProps = {
    transparent: true,
    animationType: 'fade',
    supportedOrientations: ['portrait'],
    iosBarStyle: 'dark-content',
    contentStyle: {},
    style: {},
    children: null,
    isBackdropCloseDisabled: false,
  }

  keyboardShowListener?: EmitterSubscription
  keyboardHideListener?: EmitterSubscription

  constructor(props) {
    super(props)

    this.state = {
      containerWidth: DEVICE_WIDTH,
      containerHeight: DEVICE_HEIGHT,
      keyboardVisible: Keyboard.isVisible() || false,
    }
  }

  componentDidMount() {
    if (Platform.OS !== 'web') {
      const showEvent = Platform.OS === 'ios' ? 'keyboardWillShow' : 'keyboardDidShow'
      const hideEvent = Platform.OS === 'ios' ? 'keyboardWillHide' : 'keyboardDidHide'

      this.keyboardShowListener = Keyboard.addListener(showEvent, this._handleKeyboardShow)
      this.keyboardHideListener = Keyboard.addListener(hideEvent, this._handleKeyboardHide)
    }

    if (this.props.visible) {
      // console.log('[XOverlay] Mount with visible = true → setOverlayOpen(true)')
      this.props.webBackHandler?.setOverlayOpen(true)
      this.props.webBackHandler?.setCloseOverlayFn(this._onRequestToCloseModal)
    }
  }

  componentDidUpdate(prevProps: Readonly<IXOverlayProps & WithWebBackHandlerProps>) {
    const { visible, webBackHandler } = this.props

    if (prevProps.visible !== visible) {
      if (this.props.visible) {
        // console.log('[XOverlay] visible changed → setOverlayOpen(true)')
        webBackHandler?.setOverlayOpen(true)
        webBackHandler?.setCloseOverlayFn(this._onRequestToCloseModal)
      } else {
        // console.log('[XOverlay] visible changed → setOverlayOpen(false)')
        webBackHandler?.setOverlayOpen(false)
        webBackHandler?.setCloseOverlayFn(null)
      }
    }
  }

  componentWillUnmount() {
    this.keyboardShowListener?.remove()
    this.keyboardHideListener?.remove()

    // console.log('[XOverlay] unmount → setOverlayOpen(false)')
    this.props.webBackHandler?.setOverlayOpen(false)
    this.props.webBackHandler?.setCloseOverlayFn(null)
  }

  _handleKeyboardShow = () => {
    this.setState({ keyboardVisible: true })
  }

  _handleKeyboardHide = () => {
    this.setState({ keyboardVisible: false })
  }

  _onRequestToCloseModal = () => {
    const { onRequestClose } = this.props
    if (_.isFunction(onRequestClose)) {
      onRequestClose()
    }
  }

  _onContainerLayout = (evt: LayoutChangeEvent) => {
    try {
      const { width, height } = evt.nativeEvent.layout
      if ((width && width !== this.state.containerWidth) || (height && height !== this.state.containerHeight)) {
        this.setState({ containerWidth: width, containerHeight: height })
      }
    } catch (err) {
      //
    }
  }

  _getContentWidthStyle = () => {
    const { containerWidth = DEVICE_WIDTH, containerHeight = DEVICE_HEIGHT } = this.state
    const minContentWidth = Math.floor(containerWidth / 2)
    const maxContentWidth = containerWidth - 32
    // const INITIAL_CONTENT_WIDTH = Math.floor(maxContentWidth * 0.75)

    // const minContentHeight = Math.floor(DEVICE_HEIGHT / 4)
    const minContentHeight = 50
    const maxContentHeight = containerHeight - 64

    return {
      minWidth: minContentWidth,
      maxWidth: maxContentWidth,
      minHeight: minContentHeight,
      maxHeight: maxContentHeight,

      // initial w/h
      // width: INITIAL_CONTENT_WIDTH,
      // height: INITIAL_CONTENT_HEIGHT,

      ...Platform.select({
        web: {
          minWidth: Math.floor(CONS.SPECIFIC_PLATFORM.WEB.MAIN_CONTENT_ONE_COLUMN_WIDTH * 0.75),
          maxWidth: CONS.SPECIFIC_PLATFORM.WEB.MAIN_CONTENT_ONE_COLUMN_WIDTH,
          // width: CONS.SPECIFIC_PLATFORM.WEB.MAIN_CONTENT_ONE_COLUMN_WIDTH,
          minHeight: 50,
          // minHeight: Math.floor(CONS.SPECIFIC_PLATFORM.WEB.MIN_WEB_HEIGHT * 0.5),
          maxHeight: '90%',
          // height: Math.floor(CONS.SPECIFIC_PLATFORM.WEB.MIN_WEB_HEIGHT * 0.8),
        },
      }),
    }
  }

  render() {
    const { visible, isBackdropCloseDisabled = false, onRequestClose, contentStyle, children, style = {}, ...restProps } = this.props

    if (!visible) {
      return null
    }

    const { keyboardVisible } = this.state
    //  <View style={[s.container, { paddingTop: this._getStatusBarPaddingTop() }, containerStyle]}>
    return (
      <Modal
        isVisible={visible}
        // backdropColor='red'
        onBackdropPress={isBackdropCloseDisabled ? undefined : this._onRequestToCloseModal}
        // onBackdropPress={onRequestClose}
        style={StyleSheet.flatten([{ margin: 0 }, style])}
        statusBarTranslucent={false}
        // animationIn='fadeIn'
        // animationOut='fadeOut'
        animationInTiming={0}
        animationOutTiming={0}
        backdropTransitionInTiming={0}
        backdropTransitionOutTiming={0}
        animationIn='none'
        animationOut='none'
        // useNativeDriver={false} // (สำคัญเมื่อไม่มี animation)
        hideModalContentWhileAnimating={false} // ปิดเพื่อแสดงทันที
        presentationStyle='overFullScreen'
        useNativeDriver={true}
        useNativeDriverForBackdrop={true}
        // coverScreen={false}
        // avoidKeyboard
        // style={[{ backgroundColor: 'red', alignItems: 'center', justifyContent: 'center' }, StyleSheet.flatten(style)]}
        {...(restProps as any)}>
        {/* <NativeBaseProvider> */}
        {/* <KeyboardAvoidingView style={{ flex: 1 }} behavior={Platform.OS === 'ios' ? 'padding' : 'height'}>
          <View
            style={Platform.OS === 'web' && this.state.containerWidth < 650 ? s.containerForMobileWeb : s.container}
            onLayout={this._onContainerLayout}>
            <TouchableWithoutFeedback disabled={isBackdropCloseDisabled} onPress={this._onRequestToCloseModal}>
              <View style={s.closableBg}>
                {Platform.OS === 'web' && !isBackdropCloseDisabled ? (
                  <XIconButton
                    name='close-circle-outline'
                    onPress={this._onRequestToCloseModal}
                    position='absolute'
                    top='0'
                    right='0'
                  />
                ) : null}
              </View>
            </TouchableWithoutFeedback>
            <VStack w='full' style={[s.content, this._getContentWidthStyle(), StyleSheet.flatten(contentStyle)]}>
              {children}
            </VStack>
          </View>
        </KeyboardAvoidingView> */}
        {/* <TouchableWithoutFeedback onPress={onRequestClose}>
          <View style={s.closableBg} />
        </TouchableWithoutFeedback> */}
        {/* <VStack w='full' style={s.container} onLayout={this._onContainerLayout}>
          <VStack w='full' style={[s.content, this._getContentWidthStyle(), StyleSheet.flatten(contentStyle)]}>
            {children}
          </VStack>

          {Platform.OS === 'web' && !isBackdropCloseDisabled ? (
            <XIconButton name='close-circle-outline' onPress={this._onRequestToCloseModal} position='absolute' top='0' right='0' />
          ) : null}
        </VStack> */}
        <VStack
          w='full'
          // style={s.container}
          // style={[s.container, keyboardVisible ? { justifyContent: 'flex-start', paddingTop: 8 } : { justifyContent: 'center' }]}
          style={[
            s.container,
            {
              justifyContent: keyboardVisible ? 'flex-start' : 'center',
              paddingTop: keyboardVisible ? 24 : 0,
            },
          ]}
          onLayout={this._onContainerLayout}
          pointerEvents='box-none'>
          <VStack w='full' style={[s.content, this._getContentWidthStyle(), StyleSheet.flatten(contentStyle)]}>
            {children}
          </VStack>

          {Platform.OS === 'web' && !isBackdropCloseDisabled ? (
            <XIconButton name='close-circle-outline' onPress={this._onRequestToCloseModal} position='absolute' top='0' right='0' />
          ) : null}
        </VStack>
      </Modal>
    )
  }
}

const s = StyleSheet.create({
  content: {
    // flex: 0,
    // flexBasis: 'auto',
    overflow: 'hidden',
    flexWrap: 'wrap',
    borderRadius: 8,
    // minWidth: MIN_CONTENT_WIDTH,
    // maxWidth: MAX_CONTENT_WIDTH,
    // minHeight: MIN_CONTENT_HEIGHT,
    // maxHeight: MAX_CONTENT_HEIGHT,

    // // initial w/h
    // // width: INITIAL_CONTENT_WIDTH,
    // // height: INITIAL_CONTENT_HEIGHT,

    // ...Platform.select({
    //   web: {
    //     minWidth: Math.floor(CONS.SPECIFIC_PLATFORM.WEB.MAIN_CONTENT_ONE_COLUMN_WIDTH * 0.75),
    //     maxWidth: CONS.SPECIFIC_PLATFORM.WEB.MAIN_CONTENT_ONE_COLUMN_WIDTH,
    //     // width: CONS.SPECIFIC_PLATFORM.WEB.MAIN_CONTENT_ONE_COLUMN_WIDTH,
    //     minHeight: 50,
    //     // minHeight: Math.floor(CONS.SPECIFIC_PLATFORM.WEB.MIN_WEB_HEIGHT * 0.5),
    //     maxHeight: '90%',
    //     // height: Math.floor(CONS.SPECIFIC_PLATFORM.WEB.MIN_WEB_HEIGHT * 0.8),
    //   },
    // }),

    // marginHorizontal: 8,
    // padding: 4,
    // minHeight: 50,
    backgroundColor: 'white',
    flexDirection: 'column',
  },
  container: {
    flex: 1,
    // flexBasis: 'auto',
    flexDirection: 'column',
    backgroundColor: 'transparent',
    // backgroundColor: 'red',
    alignItems: 'center',
    justifyContent: 'center',
    // alignContent: 'center',
  },
  containerForMobileWeb: {
    flex: 1,
    flexDirection: 'column',
    backgroundColor: 'transparent',
    alignItems: 'center',
    justifyContent: 'flex-start',
    alignContent: 'flex-start',
    paddingTop: 20,
    // backgroundColor: 'red',
  },
  closableBg: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    justifyContent: 'center',
    alignItems: 'center',
    // backgroundColor: 'red',
    backgroundColor: 'rgba(0,0,0,0.7)',
  },
  webCloseIconButton: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
})

export default withWebBackHandler(XOverlay) as React.FC<IXOverlayProps>
